/**
 * P4-11: Export 对话框。
 *
 * 取代 index.html `#exportDiv`：
 * - 生成 lz-string 压缩导出串；
 * - 提供 Dropbox / File(simple) / File(full) 三种导出方式；
 * - 文本框展示导出串并自动全选；
 * - 保留 `#download-link` 以兼容 `gamePage.saveToFile` 的 jQuery 实现。
 */
import { useMemo, useRef } from "react";
import { t } from "../bridge/i18n";
import { useDialog } from "../components/Dialog";

function getGamePage() {
  return (globalThis as { gamePage?: { save: () => unknown; compressLZData: (data: string) => string; saveExportDropbox: () => void; saveToFile: (full: boolean) => void } }).gamePage;
}

export default function ExportDialog() {
  const { closeTopDialog } = useDialog();
  const gamePage = getGamePage();
  const encodedData = useMemo(() => {
    if (!gamePage?.save || !gamePage?.compressLZData) {
      return "";
    }
    const data = JSON.stringify(gamePage.save());
    return gamePage.compressLZData(data);
  }, [gamePage]);

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <div className="export-dialog">
      <h1 id="exportTo">{t("save.export.to")}</h1>
      <input
        id="exportToDropbox"
        type="button"
        value={t("save.export.dropbox")}
        onClick={() => gamePage?.saveExportDropbox?.()}
      />
      <input
        id="exportToSimpleFile"
        type="button"
        value={t("save.export.file.simple")}
        onClick={() => gamePage?.saveToFile?.(false)}
      />
      <input
        id="exportToFullFile"
        type="button"
        value={t("save.export.file.full")}
        onClick={() => gamePage?.saveToFile?.(true)}
      />
      <a id="download-link" target="_blank" rel="noreferrer" style={{ display: "none" }} href="#">
        download
      </a>
      <br />
      <h1 id="exportToText">{t("save.export.text")}</h1>
      <br />
      <textarea
        id="exportData"
        ref={textareaRef}
        readOnly
        value={encodedData}
        onFocus={(e) => e.target.select()}
        style={{ width: "100%", minWidth: "320px", height: "220px" }}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
      />
      <br />
      <input
        id="closeButton"
        type="button"
        value={t("ui.close")}
        style={{ marginTop: "10px" }}
        onClick={closeTopDialog}
      />
    </div>
  );
}
